import { Pricings } from '@brands/services/identity/getPricings';

function cents(n?: number | null): number {
  return typeof n === 'number' && Number.isFinite(n) ? Math.max(0, Math.trunc(n)) : 0;
}

export function needsPayment(orgPrice: Pricings | null | undefined): boolean {
  const kind = orgPrice?.plan_decision_reason ?? 'NO_PLAN';

  const amountAfterPlan = cents(orgPrice?.amount_after_plan);
  const amount = cents(orgPrice?.amount);

  const hasPaymentOptions = (orgPrice?.payment_options?.length ?? 0) > 0;
  const needsInsurance = !!orgPrice?.collect_insurance_info;

  const isUnlimited = kind === 'UNLIMITED';
  const isFreeTier = kind === 'FREE_ALLOWANCE';
  const isPercentOff = kind.startsWith('PERCENT_OFF_');
  const isNoBenefit = kind === 'NO_BENEFIT';

  if (isUnlimited) {
    const amt = amount;
    return amt > 0 || needsInsurance || hasPaymentOptions;
  }

  if (isFreeTier) {
    const amt = amount;
    return amt > 0 || needsInsurance || hasPaymentOptions;
  }

  if (isPercentOff) {
    const amt = amountAfterPlan;
    return amt > 0 || needsInsurance || hasPaymentOptions;
  }

  if (isNoBenefit) {
    const amt = amountAfterPlan;
    return amt > 0 || needsInsurance || hasPaymentOptions;
  }

  const fallbackAmt = amountAfterPlan || amount;
  return fallbackAmt > 0 || needsInsurance || hasPaymentOptions;
}

export function isFree(orgPrice: Pricings | null | undefined): boolean {
  const kind = orgPrice?.plan_decision_reason ?? 'NO_PLAN';

  const amountAfterPlan = cents(orgPrice?.amount_after_plan);
  const amount = cents(orgPrice?.amount);

  const isUnlimited = kind === 'UNLIMITED';
  const isFreeTier = kind === 'FREE_ALLOWANCE';
  const isPercentOff = kind.startsWith('PERCENT_OFF_');
  const isNoBenefit = kind === 'NO_BENEFIT';

  if (isUnlimited) {
    const amt = amount;
    return !amt;
  }

  if (isFreeTier) {
    const amt = amount;
    return !amt;
  }

  if (isPercentOff) {
    const amt = amountAfterPlan;
    return !amt;
  }

  if (isNoBenefit) {
    const amt = amountAfterPlan;
    return !amt;
  }

  const fallbackAmt = amountAfterPlan || amount;
  return !fallbackAmt;
}

export function lastAmount(orgPrice: Pricings | null | undefined): number {
  const kind = orgPrice?.plan_decision_reason ?? 'NO_PLAN';

  const amountAfterPlan = cents(orgPrice?.amount_after_plan);
  const amount = cents(orgPrice?.amount);

  const isUnlimited = kind === 'UNLIMITED';
  const isFreeTier = kind === 'FREE_ALLOWANCE';
  const isPercentOff = kind.startsWith('PERCENT_OFF_');
  const isNoBenefit = kind === 'NO_BENEFIT';

  if (isUnlimited) {
    const amt = amount;
    return amt;
  }

  if (isFreeTier) {
    const amt = amount;
    return amt;
  }

  if (isPercentOff) {
    const amt = amountAfterPlan;
    return amt;
  }

  if (isNoBenefit) {
    const amt = amountAfterPlan;
    return amt;
  }

  const fallbackAmt = amountAfterPlan || amount;
  return fallbackAmt;
}
